import { format, startOfWeek } from "date-fns";

export const componentDatesWithData = (data) => {
  const datesWithData = data?.map((item) => item.date);
  return Array.from(new Set(datesWithData));
};

export const calculateWeeksAndMonthsWithData = (data) => {
  const weeksWithData = new Set();
  const monthsWithData = new Set();

  data.forEach((item) => {
    const { date, ...values } = item;

    const hasNonZero = Object.values(values).some((v) => Number(v) > 0);

    if (hasNonZero) {
      const parsedDate = new Date(date);
      weeksWithData.add(format(startOfWeek(parsedDate, { weekStartsOn: 1 }), "yyyy-MM-dd"));
      monthsWithData.add(format(parsedDate, "yyyy-MM"));
    }
  });

  return {
    weeksWithData: Array.from(weeksWithData),
    monthsWithData: Array.from(monthsWithData),
  };
};
